export default [
    {
        path: '/investigations/complaints/approve',
        name: 'approve-complaint',
        meta: { title: 'Review Complaint Application', authRequired: true, privileges: ['VIEW_COMPLAINTS'] },
        component: () => import('../views/investigations/approve-complaint.vue'),
    },
    {
        path: '/investigations/complaints/review',
        name: 'review-complaint',
        redirect: route => ({ name: 'prepare-complaint-investigation', query: route.query }),
    },
    {
        path: '/investigations/complaints/prepare-investigation',
        name: 'prepare-complaint-investigation',
        meta: { title: 'Prepare Complaint Investigation', authRequired: true, privileges: ['VIEW_COMPLAINTS'] },
        component: () => import('../views/investigations/prepare-complaint-investigation.vue'),
    },
    {
        path: "/investigations/complaints",
        name: "complaints",
        meta: {
            title: "Complaints",
            authRequired: true,
            privileges: [
                'VIEW_COMPLAINTS',
            ]},
        component: () => import("../views/investigations/complaints.vue"),
    },
    {
        path: "/investigations/complaints/view",
        name: "view-complaint",
        meta: {
            title: "View-Complaint",
            authRequired: true,
            privileges: [
                'VIEW_COMPLAINTS',
            ]},
        component: () => import("../views/investigations/view-complaint.vue"),
    },
    {
        path: "/investigations/investigations",
        name: "investigations",
        meta: {
            title: "Investigations",
            authRequired: true,
            privileges: [
                'VIEW_INVESTIGATIONS',
            ]},
        component: () => import("../views/investigations/investigations.vue"),
    },
    {
        path: "/investigations/investigation-types",
        name: "investigation-types",
        meta: {
            title: "Investigation Types",
            authRequired: true,
            privileges: [
                'VIEW_INVESTIGATION_TYPES',
            ]},
        component: () => import("../views/investigations/investigation-types.vue"),
    },
    {
        path: "/investigations/investigation-types/new",
        name: "new-investigation-type",
        meta: {
            title: "New Investigation Types",
            authRequired: true,
            privileges: [
                'MODIFY_INVESTIGATION_TYPE',
            ]},
        component: () => import("../views/investigations/new-investigation-type.vue"),
    },
    {
        path: "/investigations/investigation-types/view",
        name: "view-investigation-type",
        meta: {
            title: "View Investigation Types",
            authRequired: true,
            privileges: [
                'VIEW_INVESTIGATION_TYPES',
            ]},
        component: () => import("../views/investigations/view-investigation-type.vue"),
    },
    {
        path: "/investigations/investigation-types/import",
        name: "investigation-type-import",
        meta: {
            title: "Investigation Type Import",
            authRequired: true,
            privileges: [
                'MODIFY_INVESTIGATION_TYPE',
            ] },
        component: () => import("../views/investigations/view-investigation-type.vue"),
    },
    {
        path: "/investigations/new",
        name: "new-investigation",
        meta: {
            title: "New Investigation",
            authRequired: true,
            privileges: [
                'MODIFY_INVESTIGATION_TYPE',
            ]},
        component: () => import("../views/investigations/new-investigation.vue"),
    },
    {
        path: "/investigations/approve-new-investigation",
        name: "approve-investigation-process",
        meta: { title: "Approve Investigation Process", authRequired: true },
        component: () => import("../views/investigations/approve-investigation.vue"),
    },
    {
        path: "/investigations/approve-investigation-report",
        name: "approve-investigation-report",
        meta: { title: "Approve Investigation Report", authRequired: true },
        component: () => import("../views/investigations/approve-investigation-report.vue"),
    },
    {
        path: "/investigations/approve-investigation-decision",
        name: "approve-investigation-decision",
        meta: { title: "Approve Investigation Decision", authRequired: true },
        component: () => import("../views/investigations/approve-investigation-decision.vue"),
    },
    {
        path: "/investigations/view-investigation",
        name: "view-investigation",
        meta: {
            title: "View Investigation",
            authRequired: true,
            privileges: [
                'VIEW_INVESTIGATIONS',
            ] },
        component: () => import("../views/investigations/view-investigation.vue"),
    }
]
